import { isBRServer } from '@/utils/Validators/validation';

export const PRODUCTS_OFFER_IDS = {
  VPS_OPEN_CLAW: 'vps_openclaw',
  VPS_N8N: 'vps_n8n',
  DEDICATED_LINUX_SERVER: 'dedicate_linux',
};

export const PRODUCTS_OFFER_PID_BR = {
  VPS_OPEN_CLAW: 506,
  VPS_N8N: 506,
  DEDICATED_LINUX_SERVER: 539,
};

export const PRODUCTS_OFFER_PID_ES = {
  VPS_OPEN_CLAW: 308,
  VPS_N8N: 308,
  DEDICATED_LINUX_SERVER: 204,
};

export const PRODUCTS_OFFER_PID = {
  VPS_OPEN_CLAW: isBRServer ? PRODUCTS_OFFER_PID_BR.VPS_OPEN_CLAW : PRODUCTS_OFFER_PID_ES.VPS_OPEN_CLAW,
  VPS_N8N: isBRServer ? PRODUCTS_OFFER_PID_BR.VPS_N8N : PRODUCTS_OFFER_PID_ES.VPS_N8N,
  DEDICATED_LINUX_SERVER: isBRServer ? PRODUCTS_OFFER_PID_BR.DEDICATED_LINUX_SERVER : PRODUCTS_OFFER_PID_ES.DEDICATED_LINUX_SERVER,
};

export const PRICE_SYMBOLS = {
  br: 'R$',
  mx: 'MX$',
  co: 'COP$',
  cl: 'CLP$',
  ar: 'AR$',
  pe: 'S/',
  do: 'RD$',
  ec: 'US$',
  uy: 'UYU$',
  bo: 'Bs',
};
